import * as types from '../constants/actionTypes';

export default function refreshToken(store) {
    return (next) => (action) => {

        // only worry about api requests
        if (action.type === "REQUEST__STARTED") {
            if (store.getState().auth && store.getState().auth.token && store.getState().auth.isAuthenticated) {

                const tokenExpiration = store.getState().auth.expires;
                const timeLeft = tokenExpiration - (Date.now()/1000);
                if (tokenExpiration && timeLeft < 7200 && timeLeft > 0) { // refresh when there are 2 hours left
                    //console.log('need to refresh');
                    store.dispatch({
                        type: types.OAUTH__TOKEN__REFRESH__REQUESTED,
                        payload: {
                            'user_id' : store.getState().auth.id,
                            'access_token': store.getState().auth.token
                        }
                    });
                }else if (timeLeft < 0){
                    //token no longer valid, user will need to signon through CAS again
                    //console.log('need to login again');
                    store.dispatch({
                        type: types.OAUTH__TOKEN__EXPIRED,
                        payload: {
                        }
                    });
                }
            }else if (store.getState().auth.isAuthenticated){
                //token no longer valid, user will need to signon through CAS again
                //console.log('need to login again');

                store.dispatch({
                    type: types.OAUTH__TOKEN__EXPIRED,
                    payload: {
                    }
                });

            }

        }
        return next(action);
    };
}


/** WEBPACK FOOTER **
 ** ./src/connectivity/refreshToken.js
 **/